import { FC } from "react";
import { IInputProps } from "../../../modules";
import React from "react";

export const InputPhone: FC<IInputProps> = ({ onChange, onTouched, value, placeholder }) => {

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        const numbersOnly = inputValue.replace(/[^\d]/g, '');
        onChange(numbersOnly);
    };


    return (
        <input
            onChange={handleInputChange}
            onBlur={() => setTimeout(() => onTouched(), 500)}
            value={value || ''}
            placeholder={placeholder}
        />
    );
};